import { render } from "./NotFound.vue?vue&type=template&id=0d03ff45"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=0d03ff45&lang=css"

import exportComponent from "/home/runner/work/academic-pages/academic-pages/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__